/****************************************************
 * Module Name:  ConfirmationModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import { Box, Button, Typography } from "@mui/material";
import TabMenuSnackbar from "../common/tabMenuSnackbar";
import { LoadingButton } from "@mui/lab";
import logo from '../../images/pansuriya.jpg'
import RecommendIcon from '@mui/icons-material/Recommend';

function ConfirmationModal({
    show,
    setShow,
    handleSave,
    modalTitle,
    modalMessage,
    loading
}) {
    const [showError, setShowError] = useState(false);

    const saveHandler = () => {
        if (handleSave) {
            handleSave();
        }
    };

    const closeErrorDialog = () => {
        setShowError(false);
    };

    const handleClose = () => {
        setShow(false);
    };
    return (
        <div>
            <TabMenuSnackbar
                show={showError}
                message={
                    <Box>
                        Submit Total validation Failed
                        <br /> Please enter correct data
                    </Box>
                }
                variant={"error"}
                autoHide={false}
                handleClose={closeErrorDialog}
                title="Validation Failure"
            />
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={true}
                centered
                enforceFocus={false}
                dialogClassName="confirmationModal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <img
                            src={logo}
                            height="40pt"
                            width="40pt"
                            alt={Constants.COMPANY_SITE}
                        />
                        &nbsp;&nbsp;
                        {modalTitle}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Typography variant="h6" sx={{ textAlign: "center" }}>
                        {modalMessage}
                    </Typography>
                </Modal.Body>
                <Modal.Footer>
                    <LoadingButton
                        variant="contained"
                        onClick={saveHandler}
                        loading={loading}
                        loadingPosition="start"
                        startIcon={<RecommendIcon />}
                        type="Submit"
                        sx={{ mr: 3 }}
                    >
                        Confirm
                    </LoadingButton>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={handleClose}
                        sx={{ mr: 2 }}
                        disabled={loading}
                    >
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default ConfirmationModal;
